import React from 'react'

import { useAppContext } from 'app/useAppContext'
import { useWorkflows } from 'data/hooks/workflows/workflows'
import { ConfigurationLabel } from 'features/workflows/WorkflowUI'

import { Select, SelectOption } from 'ui/components/Select'

import { WorkflowActionEditorComponent } from './types'

export const InvokeFlowActionConfig: WorkflowActionEditorComponent = ({ action, onChange }) => {
    const { selectedStack } = useAppContext()
    const { data: workflows } = useWorkflows()

    // Filter workflows to only show those with "invoked" trigger type
    const invokableWorkflows = workflows?.filter(
        (workflow) => workflow.trigger?.trigger_type === 'invoked' && workflow.is_enabled
    )

    return (
        <>
            <ConfigurationLabel>Flow</ConfigurationLabel>
            <Select
                value={action.settings?.flow_id as string | undefined}
                onChange={(value) => {
                    onChange({
                        settings: {
                            ...action.settings,
                            flow_id: value,
                            stack_id: selectedStack?._sid,
                        },
                    })
                }}
                isClearable={false}
            >
                {invokableWorkflows?.map((workflow) => (
                    <SelectOption key={workflow._sid} value={workflow._sid} label={workflow.name} />
                ))}
            </Select>
        </>
    )
}
